export default {
      id: "project-type-device_audio-usage",
      viewBox: "0 0 16 16",
      url: "assets/" + "sprite.svg#project-type-device_audio-usage",
      toString: function () {
        return this.url;
      }
    }